import SeoLanding from "../components/SeoLanding";

export default function EmployeeIdCard() {
    return (
        <SeoLanding
            slug="employee"
            keyword="employee id card maker"
            audience="companies"
            seoTitle="Employee ID Card Maker — Office & Corporate ID Cards | IDCardGen"
            seoDescription="Online employee ID card maker for offices, factories and startups. Department badges, photo + QR access cards, bulk Excel import, PDF / PVC export. Free trial."
            h1="The cleanest |employee ID card maker| for modern teams."
            intro="HR-friendly templates that look like they were designed by your brand team. Bulk import from your HRMS export, generate access-card style IDs with QR or barcode, and re-issue anytime."
            features={[
                {
                    title: "Brand-matched templates",
                    body: "Match company colours, logo placement and font. Save once and your HR team reuses it across hires.",
                },
                {
                    title: "Department badges",
                    body: "Colour-coded ribbons for Engineering, Sales, Operations etc. — auto-applied based on a column in your Excel.",
                },
                {
                    title: "Employee QR / NFC",
                    body: "Encode employee ID or attendance URL into a QR / Code-128 barcode for door access integration.",
                },
                {
                    title: "Front + back layout",
                    body: "Front: photo, name, designation. Back: blood group, emergency contact, return-if-found instructions.",
                },
                {
                    title: "Visitor passes",
                    body: "Spin off a visitor / contractor template with a date stamp — generate just 1–2 cards on demand.",
                },
                {
                    title: "Re-issue & lost-card",
                    body: "Reprint individual cards without consuming bulk credits. Audit trail of every generation in the dashboard.",
                },
            ]}
            faqs={[
                {
                    q: "Can I print on PVC plastic cards?",
                    a: "Yes — export individual PNGs at 86 × 54 mm and send to your card printer (Zebra, Magicard, Fargo) or any local CR80 PVC service.",
                },
                {
                    q: "Do you support photo background removal?",
                    a: "Yes. The editor includes a one-click background remover for employee photos so they fit a clean white / branded backdrop.",
                },
                {
                    q: "How is data security handled?",
                    a: "Photos and employee data are processed in your browser before saving. Templates and exports are scoped to your account; admins can delete data anytime.",
                },
                {
                    q: "Can it integrate with our HRMS?",
                    a: "We accept any Excel / CSV export from common HRMS tools (Zoho People, Keka, GreytHR, Darwinbox). Custom integrations are available on the Premium plan.",
                },
                {
                    q: "Is there a per-card cost?",
                    a: "Buy credits in bulk — Starter (50 cards / ₹50), Standard (200 / ₹1499) or Premium (1000 / ₹4999). 1 credit = 1 card export.",
                },
            ]}
        />
    );
}
